import { render, staticRenderFns } from "./FlowTenant.vue?vue&type=template&id=40bd05bc"
import script from "./FlowTenant.vue?vue&type=script&lang=ts"
export * from "./FlowTenant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports